<template>
          <div class="mb-6">

            <div class="columns is mobile is-centered">
              <div class="column is-half">
                <section>
                  <b-field label="First Name" :label-position="labelPosition">
                    <b-input v-model="profile.firstName" disabled validation-message="Please enter a valid name"
                             pattern="[a-zA-Z]*" required></b-input>
                  </b-field>

                </section>
              </div>
              <div class="column is-half">
                <section>
                  <b-field label="Last Name" :label-position="labelPosition">
                    <b-input v-model="profile.lastName" disabled required validation-message="Please enter a valid name"
                             pattern="[a-zA-Z]*"></b-input>
                  </b-field>
                </section>
              </div>
            </div>
            <div class="columns is mobile is-centered">
              <div class="column is-half">
                <section>
                  <b-field label="Date of Birth" :label-position="labelPosition">
                    <b-input v-model="profile.dateOfBirth" placeholder="yyyy-mm-dd" v-cleave="masks.dob" required :disabled="disabled"></b-input>
                  </b-field>
                </section>
              </div>
              <div class="column is-half">
                <section>
                  <b-field label="Gender" :label-position="labelPosition">
                    <b-select v-model="profile.gender" placeholder="Select Gender"  required expanded :disabled="disabled">
                      <option value="Male">Male</option>
                      <option value="Female">Female</option>
                      <option value="X">Unspecified Gender</option>
                      <option value="U">Undisclosed Gender</option>
                    </b-select>
                  </b-field>
                </section>
              </div>
            </div>
            <div class="columns is mobile is-centered">
              <div class="column is-half">
                <section>
                  <b-field label="Mobile Phone Number" :label-position="labelPosition">
                    <b-input v-model="profile.mobilePhone" v-cleave="masks.phone" required :disabled="disabled"></b-input>
                  </b-field>
                </section>
              </div>
              <div class="column is-half">
                <section>
                  <b-field label="Email Address" :label-position="labelPosition">
                    <b-input v-model="profile.email" disabled required type="email"></b-input>
                  </b-field>
                </section>
              </div>
            </div>

          </div>  
</template>

<script>
  import Cleave from 'cleave.js';
  const cleave = {
    name: 'cleave',
    bind(el, binding) {
      const input = el.querySelector('input')
      input._vCleave = new Cleave(input, binding.value)
    },
    unbind(el) {
      const input = el.querySelector('input')
      input._vCleave.destroy()
    }
  }
export default {
      directives: {
      cleave,
    },
    props: {
        labelPosition: String,
        value: Object,
        disabled: Boolean
        
  },  
  data() {
    return {
              masks: {
          creditCard: { creditCard: true },
          numeral: {
            numeral: true,
            numeralThousandsGroupStyle: 'thousand',
            prefix: '$ '
          },
          date: {
            date: true,
            datePattern: ['m', 'y']
          },
          dob: {
            date: true,
            delimiter: '-',
            datePattern: ['Y', 'm', 'd']
          },
          phone: {
            phone: true,
            phoneRegionCode: "US",
            delimiter: "-"
          }
        },
    }
  },
  computed: {
    profile: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
      },
    },
  },
  methods: {
  },

}
</script>

<style>

</style>